import type { Papel, Perfil } from './tipos';

export interface DefinicaoDePapel {
    perfil: Perfil;
    permissoes: string[];
}

/**
 * O que cada papel alcança.
 *
 * Fica no cliente para a tela decidir o que mostrar. Não é controle de acesso:
 * quem decide o que se lê e escreve é a RLS do banco, e ela não confia nesta
 * tabela — esconder um botão nunca protegeu um dado.
 */
export const PAPEIS: Record<Papel, DefinicaoDePapel> = {
    'proprietaria': { perfil: 'clinica', permissoes: ['*'] },
    'profissional': { perfil: 'clinica', permissoes: ['agenda', 'contatos', 'atendimentos', 'documentos', 'relatorios'] },
    'recepcao': { perfil: 'clinica', permissoes: ['agenda', 'contatos', 'vendas', 'comunicacao'] },
    'financeiro': { perfil: 'clinica', permissoes: ['financeiro', 'vendas', 'relatorios', 'estoque'] },

    /* Super admin: UM só, e sem cadastro de clínica. Alcança a plataforma e, de
       lá, qualquer cliente. Nunca tem "sua" clínica: a única entrada num tenant
       é impersonação, que nasce somente-leitura e fica registrada. */
    'super-admin': {
        perfil: 'plataforma',
        permissoes: [
            '*', 'platform',
            'clientes.ver', 'clientes.editar', 'clientes.suspender',
            'modulos.alternar', 'plano.alterar',
            'creditos.adicionar', 'creditos.alterar', 'creditos.excluir',
            'faturamento.gerenciar', 'estorno.executar',
            'flags.alternar', 'usuarios.gerenciar', 'impersonar', 'auditoria.ver',
            'suporte.atender', 'ia.tetos',
        ],
    },
};

const ROTULOS: Record<Papel, string> = {
    'proprietaria': 'Proprietária',
    'profissional': 'Profissional',
    'recepcao': 'Recepção',
    'financeiro': 'Financeiro',
    'super-admin': 'Super admin',
};

export function rotuloPapel(papel: Papel): string {
    return ROTULOS[papel] ?? papel;
}
